import { render, staticRenderFns } from "./checkClass.vue?vue&type=template&id=2bde20a6&scoped=true&"
import script from "./checkClass.js?vue&type=script&lang=js&"
export * from "./checkClass.js?vue&type=script&lang=js&"
import style0 from "./checkClass.vue?vue&type=style&index=0&id=2bde20a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bde20a6",
  null
  
)

export default component.exports